var map = {
	"./de/triangle-icon.png": "ozsU",
	"./en/triangle-icon.png": "lL32",
	"./es/triangle-icon.png": "LVQQ",
	"./fr/triangle-icon.png": "qNvn",
	"./ja/triangle-icon.png": "UYEm",
	"./ko/triangle-icon.png": "gN+w",
	"./pt/triangle-icon.png": "sj7a",
	"./ru/triangle-icon.png": "Ot9h",
	"./tc/triangle-icon.png": "aD8v",
	"./th/triangle-icon.png": "x81Q"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wUzd";